"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolCardAnchorLink = exports.Title = exports.ToolCardBox = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const anchor_link_1 = __importDefault(require("../anchor-link"));
const typography_1 = __importDefault(require("../typography"));
const PREFIX = "ToolCard";
exports.classes = {
    icon: `${PREFIX}-icon`
};
exports.ToolCardBox = (0, styles_1.styled)("div")(({ theme }) => ({
    padding: "24px 20px",
    height: "100%",
    boxShadow: "0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)",
    "&:hover": {
        background: theme.colours.white,
        boxShadow: "0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)"
    },
    [theme.breakpoints.down("lg")]: {
        padding: "16px"
    },
    [`.${exports.classes.icon}`]: {
        width: "24px",
        height: "24px",
        marginRight: "16px",
        color: theme.colours.accent,
        [theme.breakpoints.up("lg")]: {
            width: "72px",
            height: "72px",
            marginRight: "0px",
            marginBottom: "24px"
        }
    }
}));
exports.Title = (0, styles_1.styled)(typography_1.default)(({ theme }) => ({
    textTransform: "none",
    maxWidth: "calc(100% - 40px)", //100% - (icon's size + margin)
    wordWrap: "break-word",
    color: theme.colours.slate,
    [theme.breakpoints.up("lg")]: {
        textAlign: "center",
        maxWidth: "100%"
    }
}));
exports.ToolCardAnchorLink = (0, styles_1.styled)(anchor_link_1.default)(({ theme }) => ({
    width: "100%",
    height: "100%",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    [theme.breakpoints.down("lg")]: {
        flexDirection: "row",
        justifyContent: "flex-start"
    }
}));
//# sourceMappingURL=data:application/json;base64,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